import { useState, useRef, useEffect } from "react";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Backdrop from "../Dialog/Backdrop";
import styles from "./CropImage.module.css";
import cross from "../../../images/Popup/Cross.svg";

export const CropImageDialog = ({
  show,
  switch: hide,
  image,
  onCropComplete,
}) => {
  const imgRef = useRef(null);
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState(null);

  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    if (!image) return;

    if (typeof image === "string") {
      setImageUrl(image);
    } else {
      setImageUrl(URL.createObjectURL(image));
    }
  }, [image]);

  const onImageLoad = (e) => {

    setCrop({
      unit: "%",
      width: 50,
      height: 50,
      x: 25,
      y: 25,
    });
  };

  const generateCroppedImage = async () => {
    if (!completedCrop || !imgRef.current) return;

    const canvas = document.createElement("canvas");
    const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
    const scaleY = imgRef.current.naturalHeight / imgRef.current.height;

    canvas.width = completedCrop.width * scaleX;
    canvas.height = completedCrop.height * scaleY;

    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imgRef.current,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, "image/png");
    });
  };

  const handleSave = async () => {
    const blob = await generateCroppedImage();
    onCropComplete(blob);
    hide();
  };

  if (!show) return null;

  return (
    <div>
      <Backdrop show={show} switch={hide} />

      <div className={styles.popup}>
        <div className={styles.cross}>
          <img src={cross} alt="close" onClick={hide} />
        </div>

        <h3
          style={{
            textAlign: "flex-start",
            marginBottom: 20,
            fontFamily: "Nunito",
          }}
        >
          Crop Image
        </h3>

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginBottom: 20,
          }}
        >
          {imageUrl && (
            <ReactCrop
              crop={crop}
              onChange={(c) => setCrop(c)}
              onComplete={(c) => setCompletedCrop(c)}
              keepSelection
              className={styles.cropArea}
            >
              <img
                ref={imgRef}
                src={imageUrl}
                alt="to crop"
                onLoad={onImageLoad}
                crossOrigin="anonymous"
              />
            </ReactCrop>
          )}
        </div>

        <div style={{ display: "flex", justifyContent: "center", gap: 20 }}>
          <button className={styles.button} onClick={hide}>
            Cancel
          </button>

          <button className={styles.button} onClick={handleSave}>
            Save Crop
          </button>
        </div>
      </div>
    </div>
  );
};
